export const OPEN_STATUS = 'CURRENT';
export const CLOSED_STATUS = 'CLOSED';
export const HIATUS_STATUS = 'HIATUS';
export const WAITLIST_STATUS = 'WAITLIST';
